<div class="modal-header">
  <h6 *ngIf="!isNeoContact" class="modal-title" id="modal-basic-title">
    {{ isEdit ? "Edit" : ("Add" + " Customer's Contact" | ioxTranslate) }}
  </h6>
  <h6 *ngIf="isNeoContact" class="modal-title" id="modal-basic-title">
    {{ isEdit ? "Edit" : ("Add" + " Neo Contacts" | ioxTranslate) }}
  </h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss('Cross click')"
  ></button>
</div>
<div class="modal-body">
  <form #dataEntryForm="ngForm" *ngIf="item">
    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label" for="name">Name</label>
      <div class="col-sm-9">
        <input
          type="text"
          class="form-control form-control-sm"
          id="name"
          [(ngModel)]="item.name"
          name="name"
          required
          #nameField="ngModel"
          [class.is-invalid]="
            nameField.invalid &&
            (nameField.dirty || nameField.touched || dataEntryForm.submitted)
          "
        />
        <div
          class="invalid-feedback"
          *ngIf="
            nameField.invalid &&
            (nameField.dirty || nameField.touched || dataEntryForm.submitted)
          "
        >
          {{ "This Field is Required" | ioxTranslate }}.
        </div>
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label" for="email">Email</label>
      <div class="col-sm-9">
        <input
          type="email"
          class="form-control form-control-sm"
          id="email"
          [(ngModel)]="item.email"
          name="email"
          #emailField="ngModel"
          email
          required
          [class.is-invalid]="
            emailField.invalid &&
            (emailField.dirty || emailField.touched || dataEntryForm.submitted)
          "
        />
        <div
          *ngIf="emailField.errors && emailField.dirty"
          class="invalid-feedback"
        >
          <div *ngIf="emailField.errors.required">Email is required.</div>
          <div *ngIf="emailField.errors.email">
            Please enter a valid email address.
          </div>
        </div>
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label" for="phone">Phone</label>
      <div class="col-sm-9">
        <input
          type="text"
          class="form-control form-control-sm"
          id="name"
          [(ngModel)]="item.phone"
          name="phone"
          required
          #phoneField="ngModel"
          [class.is-invalid]="
            phoneField.invalid &&
            (phoneField.dirty || phoneField.touched || dataEntryForm.submitted)
          "
        />
        <div
          class="invalid-feedback"
          *ngIf="
            phoneField.invalid &&
            (phoneField.dirty || phoneField.touched || dataEntryForm.submitted)
          "
        >
          {{ "This Field is Required" | ioxTranslate }}.
        </div>
      </div>
    </div>

    <div class="mb-3 row" *ngIf="isNeoContact">
      <label class="col-sm-3 col-form-label" for="line_user"
        >Line Display Name</label
      >
      <div class="col-sm-9">
        <ng-select
          id="line_user_id"
          name="line_user_id"
          [items]="lineUsers"
          bindLabel="displayName"
          bindValue="userId"
          placeholder="Select Line Display Name"
          [(ngModel)]="item.line_user_id"
          class="js-example-basic-multiple"
        >
        </ng-select>
      </div>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary btn-sm"
        (click)="closeModal()"
      >
        Close
      </button>
      <button
        *ngIf="!isNeoContact"
        type="button"
        class="btn btn-primary btn-sm"
        (click)="onSubmit()"
        [disabled]="!dataEntryForm.valid"
      >
        Save Contact
      </button>
      <button
        *ngIf="isNeoContact"
        type="button"
        class="btn btn-primary btn-sm"
        (click)="onSubmitNeoContact()"
        [disabled]="!dataEntryForm.valid"
      >
        Save Neo Contact
      </button>
    </div>
  </form>
</div>
